var path = 'src/app/patients/toggle-demographics.html';
var html = "<a href=\"\" ng-click=toggle() ng-show=visible class=no-link><i class=\"fa fa-eye-slash\"></i> <span class=link>Hide Demographics</span></a> <a href=\"\" ng-click=toggle() ng-show=!visible class=no-link><i class=\"fa fa-eye\"></i> <span class=link>Show Demographics</span></a> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/patients/toggle-demographics.html
// module id = 592
// module chunks = 0